import { Static, Type } from '@sinclair/typebox';

export const companyInspectionFormsTableSchema = Type.Object({
    inspectionFormId: Type.String({ format: 'uuid' }),
    companyId: Type.String({ format: 'uuid' }),
});

export type CompanyInspectionForm = Static<typeof companyInspectionFormsTableSchema>;

export const inspectionFormTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    inspectionStandardId: Type.String({ format: 'uuid' }),
    inspectionTemplateId: Type.String({ format: 'uuid' }),
    name: Type.String({ maxLength: 255 }),
    isActive: Type.Boolean(),
});

export type InspectionForm = Static<typeof inspectionFormTableSchema>;

export const inspectionTemplateTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    name: Type.String({ maxLength: 255 }),
    isActive: Type.Boolean(),
});

export type InspectionTemplate = Static<typeof inspectionTemplateTableSchema>;
